module.exports = __webpack_public_path__ + "static/media/AppleIconResp.118e99ae.svg";